import React from 'react';
import _ from 'lodash';

import Master from '../../Components/Master';

import User from '../User';
import BesondererDienst from '../BesondererDienst';
import Farbzuordnung from '../Farbzuordnung';
import Kalender from '../Kalender';
import Parameter from '../Parameter';
import Sonderfahrt from '../Sonderfahrt';
import Verkehrshinweis from '../Verkehrshinweis';
import Zeitraum from '../Zeitraum';

import Abteilungen from '../Abteilungen';
import Betriebsstaetten from '../Betriebsstaetten';
import Funktion from '../Funktion';
import Sortierung from '../Sortierung';
import Backup from '../Backup';
import SqlCommand from '../SqlCommand';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';


const ENDPOINT = "kontakt"

const styles = theme => ({

})

const columns = [
    "Name"
];


class ListObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        tab: 0,
    }

    tabChange = (value) => {
        this.setCookie("systemTab", value)
        this.setState({ tab: value });
    }

    constructor(props) {
        super(props)
        var tabId = parseInt(this.getCookie("systemTab"))
        if(tabId!==undefined && !isNaN(tabId)) {
            this.state.tab = tabId
        }
    }

    render() {

        var { classes } = this.props
        var { tab } = this.state

        var items = [
            //"Tätigkeiten",
            "Besonderer Dienst",
            "Farbzuordnung",
            "Zeitraum",
            "Verkehrshinweise",
            "Kalender",
            "Systemparameter",
            "Funktionen",
            "Betriebstätten",
            "Abteilungen",
            "Benutzer",
            "Leitstand Sortierung",
            "Backup",
            "Kommando",
        ]

        return (
            <div>
                <Grid container spacing={8}>
                    <Grid item xs={2}>
                        <Paper>
                            <MenuList>
                                {items.map((item, key) => (
                                    <MenuItem selected={tab === key} onClick={() => this.tabChange(key)}>{item}</MenuItem>
                                ))}
                            </MenuList>
                        </Paper>
                    </Grid>
                    <Grid item xs={10}>
                        {tab === 0 && <BesondererDienst history={this.props.history} />}
                        {tab === 1 && <Farbzuordnung history={this.props.history} />}
                        {tab === 2 && <Zeitraum history={this.props.history} />}
                        {tab === 3 && <Verkehrshinweis history={this.props.history} />}
                        {tab === 4 && <Kalender history={this.props.history} />}
                        {tab === 5 && <Parameter history={this.props.history} />}

                        {tab === 6 && <Funktion history={this.props.history} />}
                        {tab === 7 && <Betriebsstaetten history={this.props.history} />}
                        {tab === 8 && <Abteilungen history={this.props.history} />}
                        {tab === 9 && <User history={this.props.history} />}
                        {tab === 10 && <Sortierung history={this.props.history} />}
                        {tab === 11 && <Backup history={this.props.history} />}
                        {tab === 12 && <SqlCommand history={this.props.history} />}
                    </Grid>
                </Grid>
            </div>
        )
    }

}


const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/System/index.js